// src/components/Contact.js
import React, { useState } from "react";
import "../styles/contact.css";
import { sendEmail } from "../services/emailService";

const Contact = () => {
  const [form, setForm] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null); // { type: 'success' | 'error', message: string }

  const handleChange = (e) => {
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
    // Reset status kada korisnik počne tipkati
    if (submitStatus) setSubmitStatus(null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);

    try {
      const result = await sendEmail(form);
      
      if (result.success) {
        setSubmitStatus({
          type: "success",
          message: "Hvala na poruci! Javimo se u najkraćem roku.",
        });
        setForm({ name: "", email: "", message: "" });
      } else {
        setSubmitStatus({
          type: "error",
          message: result.message || result.error || "Greška pri slanju poruke. Molimo pokušajte ponovno.",
        });
        // Loguj detalje greške za debugging
        if (result.error) {
          console.error("EmailJS greška:", result.error);
        }
      }
    } catch (error) {
      setSubmitStatus({
        type: "error",
        message: "Greška pri slanju poruke. Molimo pokušajte ponovno.",
      });
      console.error("Greška:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="container contact">
      <div className="contact-left fade-in">
        <p className="section-title">Kontakt</p>
        <h2 className="section-heading">Pošaljite upit za svoju kutiju</h2>
        <p className="section-subtitle">
          Javite nam prigodu (vjenčanje, krštenje, krizma…), broj osoba ako
          naručujete više komada i okvirnu ideju dizajna. Odgovorit ćemo s
          prijedlogom i okvirnom cijenom.
        </p>

        <div className="contact-info">
          <div>
            <h3>Podaci obrta</h3>
            <p>KBIA, obrt za izradu poklona</p>
            <p>vl. Kristijan Briški</p>
          </div>
          <div>
            <p>Antuna Rašića 32</p>
            <p>35253 Brodski Stupnik</p>
          </div>
          <div>
            <p>E-mail:</p>
            <a href="mailto:dizajn.kbia@gmail.com">dizajn.kbia@gmail.com</a>
          </div>
        </div>
      </div>

      <div className="contact-right fade-in">
        <form className="contact-form" onSubmit={handleSubmit}>
          <label className="contact-label">
            Ime i prezime
            <input
              type="text"
              name="name"
              required
              value={form.name}
              onChange={handleChange}
              placeholder="Vaše ime"
            />
          </label>

          <label className="contact-label">
            E-mail
            <input
              type="email"
              name="email"
              required
              value={form.email}
              onChange={handleChange}
              placeholder="primjer@email.com"
            />
          </label>

          <label className="contact-label">
            Poruka
            <textarea
              name="message"
              required
              rows={4}
              value={form.message}
              onChange={handleChange}
              placeholder="Npr. poklon kutije za kumove, 2 komada, bijelo-zlatna kombinacija..."
            />
          </label>

          <button 
            type="submit" 
            className="btn contact-submit"
            disabled={isSubmitting}
          >
            {isSubmitting ? "Šalje se..." : "Pošalji poruku"}
          </button>

          {submitStatus && (
            <div
              className={`contact-status ${
                submitStatus.type === "success" ? "contact-status-success" : "contact-status-error"
              }`}
            >
              {submitStatus.message}
            </div>
          )}
        </form>
      </div>
    </div>
  );
};

export default Contact;
